
import dayjs from 'dayjs'
import { defineComponent, PropType } from 'vue'

import { BaseCard } from '@/components/History'
import { IssueType } from '@/components/Repository'
import { IssueSeverity, IssueTrend, TrendDirection } from '~/types/types'
import { formatDate } from '~/utils/date'
import { formatIntl, safeRenderBackticks, shortenLargeNumber } from '~/utils/string'
import { FilterParams } from './Run/AnalyzerRun.vue'

export default defineComponent({
  name: 'IssueListItem',
  components: {
    IssueType,
    BaseCard
  },
  data() {
    return {
      TrendDirection
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    shortcode: {
      type: String,
      default: ''
    },
    issueType: {
      type: String,
      default: ''
    },
    severity: {
      type: String as PropType<IssueSeverity>,
      default: null
    },
    lastSeen: {
      type: String,
      default: ''
    },
    firstSeen: {
      type: String,
      default: ''
    },
    seenIn: {
      type: String,
      default: ''
    },
    occurrenceCount: {
      type: Number,
      default: 0
    },
    autofixAvailable: {
      type: Boolean,
      default: false
    },
    centerContent: {
      type: Boolean,
      default: false
    },
    trend: {
      type: Object as PropType<IssueTrend>,
      default: null
    },
    raisedInFiles: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    issueLink: {
      type: String,
      default: ''
    },
    showAutofixButton: {
      type: Boolean,
      default: true
    },
    disableAutofixButton: {
      type: Boolean,
      default: false
    },
    showSeenInfo: {
      type: Boolean,
      default: true
    },
    issueListFilters: {
      type: Object as PropType<FilterParams>,
      default: () => ({})
    },
    issueListIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    safeRenderBackticks,
    formatDate,
    shortenLargeNumber,
    formatIntl,
    handleClick(): void {
      this.$emit('autofix', {
        shortcode: this.shortcode,
        raisedInFiles: this.raisedInFiles,
        issueId: this.id
      })
    }
  },
  computed: {
    showTrend(): boolean {
      return Boolean(this.trend && Object.keys(this.trend).length > 0)
    },
    lastSeenDisplay(): string {
      return dayjs(this.lastSeen).fromNow()
    },
    firstSeenDisplay(): string {
      return `${dayjs(this.firstSeen).fromNow(true)} old`
    },
    raisedInFilesCount(): number {
      return this.raisedInFiles?.length ?? 0
    },
    link(): string {
      let filters: string[] = []
      const filterTypes = ['category', 'sort', 'q']

      /**
       * ! These parameters are used to transfer the active filters from previous issues...
       * ! ...page to this page for arrow navigation
       * ? Ref: https://github.com/deepsourcelabs/bifrost/blob/d1c45b19d94f61159e60c71d717cf2d31ded048e/pages/_provider/_owner/_repo/run/_runId/_analyzer/_issueId.vue#L397
       */
      Object.keys(this.issueListFilters).forEach((key) => {
        if (filterTypes.includes(key)) {
          filters = filters.concat(`list${key}=${this.issueListFilters[key as keyof FilterParams]}`)
        }
      })

      filters = filters.concat(`listindex=${this.issueListIndex}`)

      return filters.length > 0 ? `${this.issueLink}?${filters.join('&')}` : this.issueLink
    }
  }
})
